import { Alert, Button } from "@mui/material";
import { Fragment } from "react";

import isChunkLoadError from "~/helpers/chunkLoadError";

interface SentryFallbackProps {
	componentStack: string;
	error: unknown;
	eventId: string;
	resetError: () => void;
}

const SentryFallback = ({ error }: SentryFallbackProps) => {
	if (isChunkLoadError(error)) {
		return (
			<Fragment>
				<Alert severity="info">
					<h3>
						Please{" "}
						<a href="/" style={{ textDecoration: "none" }}>
							<Button color="primary" variant="contained">
								Reload App
							</Button>
						</a>{" "}
						to complete update.
					</h3>
				</Alert>
			</Fragment>
		);
	}

	const errorMessage = error instanceof Error ? error.toString() : String(error);

	return (
		<Fragment>
			<Alert severity="error">
				<h3>You have encountered an error.</h3>
				<p>{errorMessage}</p>
			</Alert>
		</Fragment>
	);
};

export default SentryFallback;
